import Chart from 'chart.js';
import { colors } from './theme';

const setupChart = () => {
  Chart.defaults.global.defaultFontColor = colors.bodyText;
  Chart.defaults.global.defaultFontSize = 14;
};

export default setupChart;
